import clsx from "clsx";
import * as React from "react";
import { OpeningsTexts, SkeletonLoading } from "..";
import { CustomerOpeningsTime } from "@TmpApp/types";

export type OpeningsTimesProps = {
    title: React.ReactNode;
    isActive: boolean;
    texts?: OpeningsTexts;
} & (
    | {
          loading?: false;
          times: CustomerOpeningsTime[];
      }
    | { loading: true; times?: CustomerOpeningsTime[] }
);

const OpeningsTimes: React.FC<OpeningsTimesProps> = ({
    title,
    isActive,
    times,
    loading,
    texts: { closed = "Lukket", dinnerClosed = "Middags lukket" } = {},
    ...props
}) => {
    const returnArray = [];
    let i = 0;

    times?.map?.((time) => {
        if (i !== 0) {
            returnArray.push(dinnerClosed);
        }
        returnArray.push(time.from + " - " + time.to);
        i++;
    });

    return (
        <tr className={clsx({ "tmp-active": isActive })}>
            <td>{title}</td>
            <td>
                {loading ? (
                    <SkeletonLoading width="60%" height="1rem" />
                ) : returnArray.length < 1 ? (
                    closed
                ) : (
                    returnArray.map((value, index) => (
                        <React.Fragment key={index}>
                            {value}
                            <br />
                        </React.Fragment>
                    ))
                )}
            </td>
        </tr>
    );
};

export default OpeningsTimes;
